/**
 * FlowLight - Command Interface with Floating Button
 * Main entry point for the modular FlowLight library
 */

import { FlowLight } from './core/FlowLight.js';

// Export the main FlowLight class
export default FlowLight;

// UMD export for browser compatibility
if (typeof window !== 'undefined') {
  window.FlowLight = FlowLight;
}

// CommonJS export for Node.js compatibility
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FlowLight;
} 